var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('b-skeleton',{attrs:{"width":"30px","height":"30px","type":"avatar"}}),(!_vm.menuCollapsed)?_c('b-skeleton',{staticClass:"ml-2",attrs:{"width":_vm.computedWidth}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }